import { registerPlugin } from '@capacitor/core';
import { LocalDbPlugin } from '@/native/plugins/LocalDb/definitions';

const LocalDb = registerPlugin<LocalDbPlugin>('LocalDb', {
  web: () => import('./web').then((m) => new m.LocalDbWeb()),
});

export * from './definitions';
export { LocalDb }
